/** Dictation: the engine choice, the dictation-off card and its errors. */
export default {
  engineWindowsHint: "Live, sent to Microsoft",
  engineWhisperWindowsHint: "Private, text after each pause",
  engineAppleHint: "Live, stays on this Mac",
  engineWhisperMacHint: "More accurate, text after each pause",

  speechRecognitionOff: "Speech recognition is off",
  dictationOff: "Dictation is off",
  openSettings: "Open Settings",
  whisperGettingReady: "Dictation is getting ready",
} as const;
